import { render, staticRenderFns } from "./inputdate.vue?vue&type=template&id=6e965cc8&"
import script from "./inputdate.vue?vue&type=script&lang=js&"
export * from "./inputdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports